export default function (api) {
  return {
    setToken (context, token) {
      return api.addTokenToHeader(token)
    },

    login (context, params) {
      return api.post(`${process.env.API_URL}/auth`, params)
       .then(response => context.commit('LOGIN', response))
       .catch(error => {
         context.commit('SET_ERROR', error)
         return Promise.reject()
       })
    },

    /**
     * Clients
     */
    getClient (context, { clientId, params }) {
      return api.get(`${process.env.API_URL}/clients/${clientId}`, params)
        .then(response => context.commit('GET_CLIENT', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getClients (context, { params }) {
      return api.get(`${process.env.API_URL}/clients`, params)
        .then(response => context.commit('GET_CLIENTS', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Permissions
     */
    getPermissions (context, { params }) {
      return api.get(`${process.env.API_URL}/permissions`, params)
        .then(response => context.commit('GET_PERMISSIONS', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    setPermissions (context, { clientId, params }) {
      return api.put(`${process.env.API_URL}/clients/${clientId}/permissions`, params)
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    getClientPermissions (context, { clientId, params }) {
      return api.get(`${process.env.API_URL}/clients/${clientId}/permissions`, params)
        .then(response => context.commit('GET_CLIENT_PERMISSIONS', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Devices
     */
    getDevices (context, params) {
      return api.get(`${process.env.API_URL}/devices`, params)
        .then(response => context.commit('GET_DEVICES', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getClientDevices (context, { clientId, params }) {
      return api.get(`${process.env.API_URL}/clients/${clientId}/devices`, params)
        .then(response => context.commit('GET_CLIENT_DEVICES', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getClientDevicesByPeriods (context, params) {
      return api.get(`${process.env.API_URL}/stats/devices/totals`, params)
        .then(response => context.commit('GET_CLIENT_DEVICES_BY_PERIODS', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getAndroidDevicesTotal (context) {
      return api.get(`${process.env.API_URL}/devices?platform=android&limit=1`)
        .then(response => context.commit('GET_ANDROID_DEVICES_TOTAL', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getIosDevicesTotal (context) {
      return api.get(`${process.env.API_URL}/devices?platform=ios&limit=1`)
        .then(response => context.commit('GET_IOS_DEVICES_TOTAL', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Cameras
     */
    getCameras (context, params) {
      return api.get(`${process.env.API_URL}/cameras`, params)
        .then(response => context.commit('GET_CAMERAS', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getClientCameras (context, { clientId, params }) {
      return api.get(`${process.env.API_URL}/clients/${clientId}/cameras`, params)
        .then(response => context.commit('GET_CLIENT_CAMERAS', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getClientCamerasByPeriods (context, params) {
      return api.get(`${process.env.API_URL}/stats/cameras/totals`, params)
        .then(response => context.commit('GET_CLIENT_CAMERAS_BY_PERIODS', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getNovatekCamerasTotal (context) {
      return api.get(`${process.env.API_URL}/cameras?platform=novatek&limit=1`)
        .then(response => context.commit('GET_NOVATEK_CAMERAS_TOTAL', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getAmbarellaCamerasTotal (context) {
      return api.get(`${process.env.API_URL}/cameras?platform=ambarella&limit=1`)
        .then(response => context.commit('GET_AMBARELLA_CAMERAS_TOTAL', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getAitCamerasTotal (context) {
      return api.get(`${process.env.API_URL}/cameras?platform=ait&limit=1`)
        .then(response => context.commit('GET_AIT_CAMERAS_TOTAL', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getOtusCamerasTotal (context) {
      return api.get(`${process.env.API_URL}/cameras?platform=otus&limit=1`)
        .then(response => context.commit('GET_OTUS_CAMERAS_TOTAL', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getIcatchCamerasTotal (context) {
      return api.get(`${process.env.API_URL}/cameras?platform=icatch&limit=1`)
        .then(response => context.commit('GET_ICATCH_CAMERAS_TOTAL', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getEtronCamerasTotal (context) {
      return api.get(`${process.env.API_URL}/cameras?platform=etron&limit=1`)
        .then(response => context.commit('GET_ETRON_CAMERAS_TOTAL', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Articles
     */
    getArticle (context, { articleId, params }) {
      return api.get(`${process.env.API_URL}/articles/${articleId}`, params)
        .then(response => context.commit('GET_ARTICLE', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    getClientArticles (context, { clientId, params }) {
      return api.get(`${process.env.API_URL}/clients/${clientId}/articles`, params)
        .then(response => context.commit('GET_CLIENT_ARTICLES', response))
        .catch(error => context.commit('SET_ERROR', error))
    },

    /**
     * Update
     */
    updateClient (context, { clientId, params }) {
      return api.put(`${process.env.API_URL}/clients/${clientId}`, params)
        .then(response => context.commit('UPDATE_CLIENT', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    updateArticle (context, { articleId, params }) {
      return api.put(`${process.env.API_URL}/articles/${articleId}`, params)
        .then(response => context.commit('UPDATE_ARTICLE', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    /**
     * Create
     */
    createClient (context, data) {
      return api.post(`${process.env.API_URL}/clients`, data)
        .then(response => context.commit('CREATE_CLIENT', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    createArticle (context, data) {
      return api.post(`${process.env.API_URL}/articles`, data)
        .then(response => context.commit('CREATE_ARTICLE', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    /**
     * Upload
     */
    uploadFile (context, data) {
      return api.post(`${process.env.API_URL}/files`, data)
        .then(response => context.commit('UPLOAD_FILE', response))
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    },

    /**
     * Delete
     */
    deleteArticle (context, articleId) {
      return api.delete(`${process.env.API_URL}/articles/${articleId}`)
        .catch(error => {
          context.commit('SET_ERROR', error)
          return Promise.reject()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js